export class ProjectPartner {

    constructor(projectPartnerId:string = "", name:string = "", description:string = "") {
        this.ProjectPartnerId = projectPartnerId;
        this.Name = name;
        this.Description = description;
    }
    
    public ProjectPartnerId: string;
    public Name: string;
    public Description: string;

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/ng-router-loader?{"loader":"async-system","genDir":"compiled","aot":false}!./src/app/entities/project-partner.ts